import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9.647 12.294l6.353 3.706l-4 -9l-4 9","key":"svg-1"}]]

const IconBrandAnsible = createReactComponent('outline', 'brand-ansible', 'BrandAnsible', __iconNode);

export default IconBrandAnsible;